<template>
  <div data-qa="contacts-item-block">
    <h2
      v-if="contact.department_name"
      data-qa="contacts-item-title"
      class="text-h6 text--text mt-0"
      :class="isMobile ? 'mb-4' : 'mb-3'"
    >
      {{ transDynamic(contact, `department_name,${language},${needTranslate}`) }}
    </h2>

    <p
      v-if="contact.work_start_time && contact.work_end_time"
      data-qa="contacts-item-time"
      class="text-body-1 text-secondary--text"
      :class="isMobile ? 'mb-4' : 'mb-3'"
    >
      <template v-if="contact.work_start_time === contact.work_end_time">
        {{ t('Круглосуточно', options) }}
      </template>
      <template v-else>
        <time>{{ formattedTime(contact.work_start_time) }}</time> —
        <time>{{ formattedTime(contact.work_end_time) }}</time>
        {{ transDynamic(contact, `timezone_text,${language},${needTranslate}`) }}
      </template>
    </p>

    <a
      v-if="contact.email"
      data-qa="contacts-item-email"
      class="text-body-1 link-decoration-none primary--text"
      :class="isMobile ? 'd-table mb-4' : 'd-inline-flex mb-3'"
      :href="`mailto:${contact.email}`"
    >{{ contact.email }}</a>

    <ContactsPhones :phones="contact.phones.all" />

    <ContactsMessengers
      v-if="contact.messengers.all.length"
      :messengers="contact.messengers.all"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import I18NextVue from 'i18next'
import { format, parse } from 'date-fns'
import { useContextStore } from 'src/store'
import ContactsPhones from 'src/components/pages/info/contacts/components/ContactsPhones.vue'
import ContactsMessengers from 'src/components/pages/info/contacts/components/ContactsMessengers.vue'
import type { ContextStore } from 'src/components/pages/info/contacts/types'
import getDateFnsLocaleByIso from 'www/utils/get/getDateFnsLocaleByIso'
import transDynamic from 'djanjucks/filters/transDynamic'

const { t, language } = I18NextVue
const options = { ns: language }
const { context }: ContextStore = useContextStore()

const isMobile = computed(() => context?.flavour === 'mobile')
const needTranslate = context.feature_flags.pd_l10n_footer_pages

defineProps<{
  contact: ContextStore['context']['company_contacts'][number]
}>()

const formattedTime = (time: string) => {
  const timeISO = parse(time, 'HH:mm:ss', new Date(), { locale: getDateFnsLocaleByIso(language) })

  return format(timeISO, 'HH:mm', { locale: getDateFnsLocaleByIso(language) })
}
</script>
